document.querySelectorAll('.variant-form-group').forEach( it =>{
  //helper for add to cart button, if quantity is 0, add to 1
  //after submit, revert quantity to 0;
  const variantForms = it.querySelectorAll('.variant-form');
  variantForms.forEach(x => {
    const form = x.querySelector('form');
    form.addEventListener('submit', ev => {
      ev.preventDefault();
      if(parseInt(form.quantity.value) <= 0)form.quantity.value = 1;
      form.submit();
    })
  });
  
  //show hide variant form by use form selector
  const select = it.querySelector('.form-select');
  if(!select) return;
  select.addEventListener('change', ev =>{
    variantForms.forEach(x => x.classList.remove('active')); //reset forms

    const variantForm = document.getElementById('variant-form-'+select.value); //enable form
    variantForm.classList.add('active');
  })
})